export default "__VITE_ASSET__Ce0Wt_XD__"